import React from 'react'
import {
    Box,
    Text,
    TextareaProps,
    Textarea,
    BoxProps,
    HStack,
} from '@chakra-ui/react'
import SharedLabel from './shared-label'

interface Props extends TextareaProps {
    label?: string
    helpText?: string
    containerProps?: BoxProps
}

const SharedTextarea: React.FC<Props> = ({
    label,
    helpText,
    containerProps,
    ...props
}) => {
    return (
        <Box w="100%" {...containerProps}>
            <HStack>
                {label && (
                    <SharedLabel mb={helpText ? 0 : 1}>{label}</SharedLabel>
                )}
                {props.isRequired && (
                    <Text
                        fontSize="xs"
                        color="gray.500"
                        mb={1}
                        fontStyle="italic"
                    >
                        Required
                    </Text>
                )}
            </HStack>

            {helpText && (
                <Text fontSize="sm" color="gray.500" mb={2}>
                    {helpText}
                </Text>
            )}
            <Textarea
                borderWidth={1}
                focusBorderColor="brand.400"
                minH="40px"
                maxH="296px"
                w="full"
                {...props}
            />
        </Box>
    )
}

export default SharedTextarea
